export default "<div class=\"loading-spinner-wrapper\">\n    <mat-spinner></mat-spinner>\n</div>\n"